import { useContext } from 'react'
import {
    ConfiguracionInicialContext
} from '../context/ConfiguracionInicialContext'
import { ConfiguracionInicialContextType } from '../interfaces/ConfiguracionInicial.interfaces'

const useConfiguracionInicial = (): ConfiguracionInicialContextType => {
    const context = useContext(ConfiguracionInicialContext)

    if (!context) {
        throw new Error(
            'useConfiguracionInicial debe usarse dentro de <ConfiguracionInicialProvider>'
        )
    }

    return context
}

export default useConfiguracionInicial